import { Col, Modal, Row } from "react-bootstrap"
import { Employee, modal_screen_sizes } from "@utils/globalTypes"
import React, { FC } from "react"

import { BaseBlockContent } from "@utils/richText"
import { GatsbyImage } from "gatsby-plugin-image"
import * as s from "./EmployeeDetail.module.scss"
import useResizeWidth from "@hooks/useResizeWidth"

type Props = {
  show: boolean
  onHide(): void
  employee?: Employee
}

const EmployeeDetail: FC<Props> = ({ show, onHide, employee }) => {
  const { position, name, _rawBio, image } = employee
  const { screenType } = useResizeWidth()
  let modalSize = modal_screen_sizes[screenType]
  if (!employee) {
    return <></>
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={modalSize}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      dialogClassName={s.container}
    >
      <Modal.Header className={s.header} closeButton>
        <Modal.Title className={s.title}>
          <b>{name}</b> - <span> {position} </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} lg={4} className={s.imageContainer}>
            <GatsbyImage
              imgStyle={{ objectFit: "contain" }}
              style={{ height: "100%" }}
              alt={name}
              image={image.asset.gatsbyImageData}
            />
          </Col>
          {_rawBio && (
            <Col xs={12} lg={8} className={s.textContainer}>
              <BaseBlockContent blocks={_rawBio} />
            </Col>
          )}
        </Row>
      </Modal.Body>
    </Modal>
  )
}
export default EmployeeDetail
